export const CURRENT_CUSTOMER_CHANGED_EVENT = 'currentCustomerChanged';

export const notifyCurrentCustomerChanged = () => {

  window.dispatchEvent(new Event(CURRENT_CUSTOMER_CHANGED_EVENT));

};

type CustomerOption = { value: string; label: string };

export const getCurrentCustomer = (): CustomerOption | null => {

  const currentCustomerString = sessionStorage.getItem('currentCustomer') || localStorage.getItem('lastSavedCustomer');

  if (currentCustomerString) {

    return JSON.parse(currentCustomerString);

  }

  const allCustomersString = localStorage.getItem('customers');
  if (allCustomersString) {

    const allCustomers = JSON.parse(allCustomersString);
    if (allCustomers.length) {

      return allCustomers[0];

    }

  }

  return null;

};

const getAccessRequestCustomer = (): CustomerOption | null => {

  try {

    const raw = sessionStorage.getItem('currentCustomer') || localStorage.getItem('lastSavedCustomer');
    if (!raw) {

      return getCurrentCustomer();

    }
    const parsed = JSON.parse(raw) as CustomerOption;
    if (!parsed?.value) {

      return getCurrentCustomer();

    }
    let list: CustomerOption[] = [];
    try {

      list = JSON.parse(localStorage.getItem('customers') || '[]');

    } catch {

      list = [];

    }
    if (!list.length) {

      return parsed;

    }
    return list.find((c) => c.value === parsed.value) ?? parsed;

  } catch {

    return getCurrentCustomer();

  }

};

/** Access-request page snapshot: keeps stored customer when missing from customers list. */
export const getAccessRequestCustomerSnapshot = (): string => {

  const customer = getAccessRequestCustomer();
  return customer ? JSON.stringify(customer) : '';

};
